<template>
  <div id="app">
    <HeaderStyles1 />
    <router-view />
    <PageFooter />
    <CookiesConsent />
  </div>
</template>

<script>
import PageFooter from './components/PageFooter'
import HeaderStyles1 from './components/HeaderStyles1'
import CookiesConsent from './components/CookiesConsent.vue'

export default {
  components: {
    HeaderStyles1,
    PageFooter,
    CookiesConsent
  },
  mounted() {
    document.title = 'Compathnion | Smart Solution for Location Service'
  }
}
</script>
